<template>
  <div class="board-tools">
    <!-- Invia disegno a Cloudinary -->
    <el-dialog
      :title="config.send.title[lang]"
      :visible.sync="sendDrawingDialog"
      width="60%">
      <div>
        <div class="form-group">
          <div class="form-group__label">{{ config.send.input.title[lang] }}</div>
          <input
            id="sendTitle"
            :placeholder="config.send.input.title[lang]"
            type="text"
            name="sendTitle"
            autofocus
            class="form-group__input"
            @focus="showKeyb"
            @blur="lostFocus"
          >
        </div>
        <div class="form-group">
          <div class="form-group__label">{{ config.send.input.description[lang] }}</div>
          <input
            id="sendDesc"
            :placeholder="config.send.input.description[lang]"
            type="text"
            name="sendDesc"
            class="form-group__input"
            @focus="showKeyb"
            @blur="lostFocus"
          >
        </div>
        <div class="form-group">
          <div class="form-group__label">{{ config.send.input.from[lang] }}</div>
          <input
            id="sendFrom"
            :placeholder="config.send.input.from[lang]"
            type="text"
            name="sendFrom"
            class="form-group__input"
            @focus="showKeyb"
            @blur="lostFocus"
          >
        </div>
        <vue-touch-keyboard
          v-if="showKeyb"
          id="keyboard"
          :layout="config.layout[lang]"
          :cancel="hideKeyb"
          :accept="acceptKeyb"
          :input="input"
          :next="next"
        />
      </div>
    </el-dialog>

    <!-- Colore del pennello -->
    <color-picker
      v-model="drawData.brushColor"
      :close="closeColor"
      :label="config.board.colorPicker[lang]"
      :is-active="!drawData.isEraser"
      @menuopen="closePickers('colorPicker')"
      @selected="$emit('usebrush')"
    />

    <!-- Usa la gomma -->
    <div
      :class="{'active': drawData.isEraser}"
      class="box"
      @click="$emit('useeraser'); closePickers();"
    >
      <i class="fas fa-eraser box__icon" />
      {{ config.board.eraser[lang] }}
    </div>

    <!-- Dimensione del pennello -->
    <size-picker
      v-model="drawData.brushSize"
      :close="closeSize"
      :label="config.board.sizePicker[lang]"
      @menuopen="closePickers('sizePicker')"
    />

    <!-- Cancella tutto -->
    <div
      class="box"
      @click="$emit('clearboard'); closePickers();"
    >
      <i class="fas fa-trash-alt box__icon" />
      {{ config.board.clear[lang] }}
    </div>

    <!-- Invia a Cloudinary -->
    <div
      :style="disabledButton"
      class="board-tools__send box"
      @click="showDialog()"
    >
      <i class="fas fa-share-square box__icon" />
      {{ config.board.send[lang] }}
    </div>

    <!-- Seleziona la lingua -->
    <lang-picker
      ref="lang"
      v-model="lang"
      class=""
      @menuopen="closePickers('langPicker');"
    />
  </div>
</template>

<script>
import Translation from "../translation.js";
import VueTouchKeyboard from "vue-touch-keyboard";

export default {
  components: {
    "vue-touch-keyboard": VueTouchKeyboard.component
  },

  props: {
    hideSend: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      sendDrawingDialog: false,
      closeColor: false,
      closeSize: false,
      lang: "IT",

      keybVisible: false,
      input: null,
      options: {
        useKbEvents: false
      }
    };
  },

  computed: {
    disabledButton: function() {
      if (this.hideSend) return "background-color: grey; opacity: 0.5;";
    },
    drawData: {
      set: function(newValue) {
        this.$emit("input", newValue);
      },
      get: function() {
        return this.value;
      }
    },
    config: function() {
      return Translation;
    },
    isEraserStyle: function() {
      if (this.drawData.isEraser)
        return "border: 2px solid rgba(0, 0, 255, 1);";
      return "";
    },
    pickerStyle: function() {
      return `background-color: ${this.drawData.color}`;
    }
  },

  watch: {
    lang: function() {
      this.drawData.lang = this.lang;
    }
  },

  methods: {
    acceptKeyb: function() {
      if (this.input.value == "<relPageNow>") location.reload();
      if (this.input.id == "sendFrom") {
        this.$emit("sendimg");
        this.keybVisible = false;
        this.sendDrawingDialog = false;

        // Svuota tutti i campi
        let inputs = document.querySelectorAll("input");
        [].forEach.call(inputs, input => {
          input.value = "";
        });
      } else {
        this.next();
      }
    },
    closePickers: function(doNotClose) {
      if (doNotClose != "colorPicker") this.closeColor = !this.closeColor;
      if (doNotClose != "sizePicker") this.closeSize = !this.closeSize;
      if (doNotClose != "langPicker") this.$refs.lang.closeMenu();
    },
    lostFocus: function(e) {
      this.drawData[e.target.id] = e.target.value;
    },
    showDialog: function() {
      if (this.hideSend) {
        return;
      }
      this.sendDrawingDialog = true;
      this.closePickers();
    },
    showKeyb: function(e) {
      this.input = e.target;
      if (!this.keybVisible) this.keybVisible = true;
    },
    hideKeyb: function() {
      this.keybVisible = false;
    },
    next: function() {
      if (this.input.id == "sendForm") {
        this.input.blur();
        this.hideKeyb();
      } else {
        let inputs = document.querySelectorAll("input");
        let found = false;
        [].forEach.call(inputs, (item, i) => {
          if (!found && item == this.input && i < inputs.length - 1) {
            found = true;
            this.$nextTick(() => {
              inputs[i + 1].focus();
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.board-tools {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  &__lang {
  }

  &__send {
    &.box {
      margin-left: 10rem;
      background-color: #398992;
      border: 1px solid darken(#398992, 10%);
      color: white;
    }
  }
}

.reload {
  margin-left: 4rem;
}

#keyboard {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 1000;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  padding: 1em;

  background-color: #eeeeee;
  box-shadow: 0px -3px 10px rgba(black, 0.3);

  border-radius: 10px;
}
</style>
